var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { "margin-top": "30px" } }, [
        _c("h1", { staticStyle: { display: "inline" } }, [
          _vm._v(_vm._s(_vm.$t("booking.budgetUtilization")))
        ])
      ]),
      _c("booking-menu"),
      _c(
        "v-row",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mr-0",
              attrs: { color: "primary" },
              on: { click: _vm.clearDefaults }
            },
            [_vm._v(_vm._s(_vm.$t("booking.clearBudget")))]
          ),
          _c(
            "v-btn",
            {
              staticClass: "ml-0",
              attrs: { color: "success", to: "/booking/report/budget/new" }
            },
            [_vm._v(_vm._s(_vm.$t("booking.addBudget")))]
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: { items: _vm.items, headers: _vm.headers },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [
                    _c(
                      "h3",
                      [
                        _vm._v(" " + _vm._s(props.item.name) + " "),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      props.item.is_default
                                        ? _c(
                                            "v-icon",
                                            _vm._g(
                                              { attrs: { color: "success" } },
                                              on
                                            ),
                                            [_vm._v("attach_money")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("booking.defaultBudget")) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      props.item.is_flight_default
                                        ? _c(
                                            "v-icon",
                                            _vm._g(
                                              { attrs: { color: "primary" } },
                                              on
                                            ),
                                            [_vm._v("flight")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("booking.flightBudget")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("td", [_vm._v(_vm._s(props.item.start_date))]),
                  _c("td", [_vm._v(_vm._s(props.item.end_date))]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.serviceTypesNames.find(function(v) {
                          return v.value === props.item.service_type_group
                        }).text
                      )
                    )
                  ]),
                  _c("td", [_vm._v(_vm._s(props.item.amount))]),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm.fieldTypesNames.find(function(v) {
                          return v.value === props.item.calculate_by_field
                        }).text
                      )
                    )
                  ]),
                  _c("td", [
                    _c("span", { staticStyle: { "font-weight": "bold" } }, [
                      _vm._v(
                        _vm._s(props.item.utilization) +
                          "/" +
                          _vm._s(props.item.amount)
                      )
                    ])
                  ]),
                  _c(
                    "td",
                    { staticStyle: { "min-width": "150px" } },
                    [
                      _c("v-progress-linear", {
                        staticStyle: {
                          margin: "3px 5px 0",
                          width: "100px",
                          display: "inline-block"
                        },
                        attrs: {
                          value: _vm.percentageUtilization(props.item),
                          color:
                            _vm.percentageUtilization(props.item) > 100
                              ? "error"
                              : "success",
                          height: "12",
                          width: "50px"
                        }
                      }),
                      _c(
                        "span",
                        {
                          class:
                            _vm.percentageUtilization(props.item) > 100
                              ? "error--text"
                              : "success--text"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  (props.item.utilization / props.item.amount) *
                                  100
                                ).toFixed(2)
                              ) +
                              " %"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _c(
                        "v-menu",
                        {
                          staticStyle: { display: "inline" },
                          attrs: { "offset-y": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var menu = ref.on
                                  return [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var tooltip = ref.on
                                                return [
                                                  _c(
                                                    "v-btn",
                                                    _vm._g(
                                                      { attrs: { icon: "" } },
                                                      Object.assign(
                                                        {},
                                                        tooltip,
                                                        menu
                                                      )
                                                    ),
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "featured_play_list"
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("booking.setShowBudget")
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.setAsDefault(props.item.id)
                                    }
                                  }
                                },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("booking.defaultBudget")
                                        ) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.setAsFlightDefault(
                                        props.item.id
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("booking.flightBudget")) +
                                        " "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$router.push(
                                                "/booking/report/budget/edit/" +
                                                  props.item.id
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("edit")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.edit")) + " ")]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.remove(props.item.id)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("delete")])],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.delete")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }